import { html } from 'lit';
import { Award } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-award')
export class PdsIconAward extends PdsIcon {
  @state()
  icon = Award;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
